import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { FaPlus, FaSpinner } from 'react-icons/fa';
import ReactSelect from 'react-select';
import errorSound from '../../../assets/audio/error.mp3';
import useSound from 'use-sound';
import useIsMobile from 'utils/isMobileUtils';


const InboundingForm = ({
    operationDetails,
    handleErrorDialog,
    handleUpdateOperationDetailsProducts,
    handleBulkUpdateOperationDetailsProducts,
    handleUpdatePurchaseOrder,
    handleUpdateWarehouse,
}) => {

	const [colors, setColors] = useState([]);
	const [warehouses, setWarehouses] = useState([]);
    const [errorSoundPlay] = useSound(errorSound);
    const [productList, setProductList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [isPasted, setIsPasted] = useState(false);
    const [isColorsSelectionLoading, setIsColorsSelectionLoading] = useState(false);
    const [purchaseOrderList, setPurchaseOrderList] = useState([]);
    const [showClassificationField, setShowClassificationField] = useState(true);

    
    const [itemDetails, setItemDetails] = useState({
        id: '',
        categoryId: '',
        categoryName: '',
        product_id: '',
        product_name: '',
        quantity: 1,
        color_id: '',
        color_name: '',
        imei: '',
        warehouse_id: '',
        warehouse_name: '',
    });

    useEffect(() => { 
        
        api.getSelectOptionsList('all_products').then((res) => {
            if (res?.data) {
                const products = res?.data?.map((item) => { 
                    item.label = item.product_name;
                    item.value = item.id;
                    item.allow_serial = item.allow_serial;
                    return item;
                });
                setProductList(products);
            }
        });
        api.getSelectOptionsList('get_purchase_orders_for_inbounding').then((res) => {
          if (res?.status) {
                const tempList = res.data.map((item) => ({
                    ...item,
                    label: `${item.option_label_name}`,
                    value: item.id,
                }));
                setPurchaseOrderList(tempList);
            }
        });
        
        api.getSelectOptionsList('warehouse').then((res) => {
            if (res?.data) {
                const warehouse = res?.data?.map((item) => { 
                    item.label = item.name;
                    item.value = item.id;
                    return item;
                });
                if (operationDetails?.warehouseId === '') {

                    handleUpdateWarehouse(warehouse[0]?.value)
                }
                setWarehouses(warehouse);
            }
        });
    }, []);

    const getProductModelColorsById = () => {
        setItemDetails({
            ...itemDetails,
            color_id: '',
            color_name: '',
        })
        setIsColorsSelectionLoading(true)
        api.getProductModelColorsById(itemDetails?.product_id).then((res) => {
            if (res?.data) {
                const colors = res?.data?.map((item) => { 
                    item.label = item.name;
                    item.value = item.id;
                    return item;
                });
                setIsColorsSelectionLoading(false)
                setColors(colors);
            }
        });
    }

    useEffect(() => {
        if (itemDetails?.product_id) {
            getProductModelColorsById()
        }
    }, [itemDetails?.product_id]);


	const showErrorDialog = (title, message = '') => {
		handleErrorDialog({
			show: true,
			message: message,
			title: title
		});
	};

	const handleIMEIInputKeydown = (event) => {
        if (event.key === 'Enter') {
            if (/\r|\n/.test(itemDetails?.imei)) {
                // IMEI contains a line break
			    addModalBulkImei();
                // NOTE: IMEI has a breakspace (newline)';
            } else {
			    addModalImei();
                // NOTE: IMEI does not have a breakspace (newline)';
            }
		}
    };

    
    const handleInboundItem = () => {
        if (!itemDetails?.product_id) {
            showErrorDialog('Product is required', `Please select a product`);
            return;
        }

        if (!itemDetails?.quantity) {
            showErrorDialog('Quantity is required', `Please enter a quantity`);
            return;
        }
        if (showClassificationField) {
            if (!itemDetails?.color_name) {
                showErrorDialog('Color is required', `Please select a color`);
                return;
            }
            if (!itemDetails?.imei) {
                showErrorDialog('IMEI is required', `Please enter an IMEI`);
                return;
            }
            if (itemDetails?.imei) {

                if (/\r|\n/.test(itemDetails?.imei)) {
                    // IMEI contains a line break
                    addModalBulkImei();
                    // NOTE: IMEI has a breakspace (newline)';
                } else {
                    addModalImei();
                    // NOTE: IMEI does not have a breakspace (newline)';
                }
                
                const imeiExists = operationDetails?.products?.find(product => product.imei === itemDetails?.imei);
                if (imeiExists) {
                    showErrorDialog(`IMEI already inbounded`);
                    setItemDetails({ ...itemDetails, imei: '' });
                    errorSoundPlay();
                    return false;
                }
            }
        } else {
            inboundWithoutImei();
        }
    };

	const addModalImei = async () => {
		if (!itemDetails?.imei || !itemDetails?.imei?.trim()) {
            showErrorDialog('IMEI is required', `Invalid IMEI Entered`);
            setItemDetails({ ...itemDetails, imei: '' });
			return;
		}

		const alphanumericRegex = /^[0-9a-zA-Z]{10,16}$/;

		if (!alphanumericRegex.test(itemDetails?.imei)) {
			showErrorDialog(`Please enter a valid IMEI Number`);
            setItemDetails({ ...itemDetails, imei: '' });
			return;
        }

        const imeiExists = operationDetails?.products?.find(product => product.imei === itemDetails?.imei);
        
        if (imeiExists) {
			showErrorDialog(`IMEI ${itemDetails?.imei} is already inbounded`);
            setItemDetails({ ...itemDetails, imei: '' });
            errorSoundPlay();
            return false;
        }
        
        const newData = {
            id: itemDetails?.id,
            categoryId: itemDetails?.categoryId,
            categoryName: itemDetails?.categoryName,
            product_id: itemDetails?.product_id,
            product_name: itemDetails?.product_name,
            quantity: itemDetails?.quantity,
            color_id: itemDetails?.color_id,
            color_name: itemDetails?.color_name,
            imei: itemDetails?.imei,
            status: 'Pending',
        }

        handleUpdateOperationDetailsProducts(newData)
        
        setItemDetails({
            ...itemDetails,
            quantity: 1,
            imei: '',
        })
    };


	const inboundWithoutImei = async () => {
        const productExists = operationDetails?.products?.find(product => product.product_id === itemDetails?.product_id);
        if (productExists) {
			showErrorDialog(`Product ${itemDetails?.product_name} is already inbounded`);
            setItemDetails({ ...itemDetails, product_id: '', product_name: '', quantity: 1 });
            errorSoundPlay();
            return false;
        }

        const newData = {
            id: itemDetails?.id,
            categoryId: itemDetails?.categoryId,
            categoryName: itemDetails?.categoryName,
            product_id: itemDetails?.product_id,
            product_name: itemDetails?.product_name,
            quantity: itemDetails?.quantity,
            color_id: itemDetails?.color_id,
            color_name: itemDetails?.color_name,
            imei: itemDetails?.imei,
            status: 'Pending',
        }

        handleUpdateOperationDetailsProducts(newData)
        
        setItemDetails({
            ...itemDetails,
            quantity: 1,
            product_id: '',
            product_name: '',
            color_id: '',
            color_name: '',
            imei: '',
        })
        setShowClassificationField(true);
    };

	const addModalBulkImei = async () => {
            if (!itemDetails?.imei || !itemDetails?.imei.trim()) {
                showErrorDialog('IMEI is required', `Invalid IMEI Entered`);
                setItemDetails({ ...itemDetails, imei: '' });
                return;
            }

            const imeiList = itemDetails.imei
                .split(/\r?\n/)
                .map(i => i.trim())
                .filter(i => i);

            const alphanumericRegex = /^[0-9a-zA-Z]{10,16}$/;

            let hasError = false;
            let validImeis = [];
            let invalidImeis = [];

            imeiList.forEach(imei => {
                if (!alphanumericRegex.test(imei)) {
                    showErrorDialog(`Invalid IMEI: ${imei}`);
                    hasError = true;
                } else {
                    const imeiExists = operationDetails?.products?.find(product => product.imei === imei);
                    if (imeiExists) {
                        // showErrorDialog(`IMEI already inbounded: ${imei}`);
                        hasError = true;
                        // errorSoundPlay();
                        invalidImeis.push(imei);
                    } else {
                        const newData = {
                            id: itemDetails?.id,
                            categoryId: itemDetails?.categoryId,
                            categoryName: itemDetails?.categoryName,
                            product_id: itemDetails?.product_id,
                            product_name: itemDetails?.product_name,
                            quantity: itemDetails?.quantity,
                            color_id: itemDetails?.color_id,
                            color_name: itemDetails?.color_name,
                            imei: imei,
                            status: 'Pending',
                        };
                        validImeis.push(newData);
                    }
                }
            });

            if (hasError) {
                const err_message = `<ul style="text-align: left; margin: 0;">${invalidImeis.map(i => `<li>${i}</li>`).join('')}</ul>`;
                showErrorDialog('Invalid or already inbounded IMEIs:', err_message);
                
                hasError = true;
                errorSoundPlay();
            }
            if (validImeis.length > 0) {
                // Send all valid IMEIs at once
                handleBulkUpdateOperationDetailsProducts(validImeis);
            }

            setItemDetails({
                ...itemDetails,
                quantity: 1,
                imei: '',
            });
    };

    const isMobile = useIsMobile();
    
    return (
        <div>
            
            <div className="form-group">
                <h5>Product Details</h5>
            </div>

            <div className="row align-items-top form-group">
                <div className="col-12" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                    <div className="textGray" style={{ width: '100px' }}>Purchase Order</div>
                    <div style={{ width: isMobile ? '250px' : '350px', marginLeft: '10px', textAlign: 'left' }}>
                            <ReactSelect
                                className="rs-container"
                                classNamePrefix="rs"
                                options={[...purchaseOrderList]?.map((m) => ({
                                    ...m,
                                    optionAttribute: m.attribute,
                                }))}
                                value={operationDetails?.purchaseInvoiceId ? purchaseOrderList?.find((c) => c?.value == operationDetails?.purchaseInvoiceId) : null}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                placeholder="Select or type..."
                                formatOptionLabel={({ label, optionAttribute }) => (
                                    <div dangerouslySetInnerHTML={{ __html: label }}></div>
                                )}
                                onChange={(e) => {
                                    handleUpdatePurchaseOrder(e?.value)
                                }}
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        overflowY: 'auto', // Enable vertical scrolling
                                    }),
                                    option: (provided, { selectProps, data }) => {
                                        // Find the index of the current option
                                        const index = selectProps.options.findIndex(option => option.value === data.value);
                                        return {
                                        ...provided,
                                        marginBottom: '5px', // Existing space between options
                                        marginTop: index === 0 ? '10px' : 0, // Add more spacing on top of the first option
                                        };
                                    },
                                }}
                            />
                    
                    </div>
                </div>
            </div>

            <div className="row align-items-top form-group">
                <div className="col-12" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                    <div className="textGray" style={{ width: '100px' }}>Product</div>
                    <div 
                        style={{ 
                            width: isMobile ? '250px' : '350px', 
                            marginLeft: '10px', 
                            textAlign: 'left', 
                            background: `${(operationDetails?.status === 'Completed') ? '#eaeaea' : ''}`, 
                            borderRadius : '12px'
                        }}
                    >
                        <Select
                            placeholder="Select or type..."
                            className={`rs-container ${(operationDetails?.status === 'Completed') ? 'disabled' : ''}`}
                            classNamePrefix="rs"
                            options={productList}
                            value={itemDetails?.product_id ? categoryList?.find((c) => c?.value == itemDetails?.product_id) : null}
                            onChange={(e) => {
                                // setSelectedProduct(e);
                                setItemDetails({
                                    ...itemDetails,
                                    product_id: e.value,
                                    product_name: e.label,
                                    quantity: 1,
                                });
                                if (e?.allow_serial === 'Yes') {
                                    setShowClassificationField(true);
                                } else {
                                    setShowClassificationField(false);
                                }
                            }}
                            isDisabled={(operationDetails?.status === 'Completed') ? true : false}
                        />
                    </div>
                </div>
            </div>
            <div className="row align-items-top form-group">
                <div className="col-12" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                    <div className="textGray" style={{ width: '100px' }}>Warehouse</div>
                    <div 
                        style={{ 
                            width: isMobile ? '250px' : '350px', 
                            marginLeft: '10px', 
                            textAlign: 'left', 
                            background: `${(operationDetails?.status === 'Completed') ? '#eaeaea' : ''}`, 
                            borderRadius : '12px'
                        }}
                    >
                        <ReactSelect
                            className="rs-container"
                            classNamePrefix="rs"
                            name="customer"
                            options={warehouses}
                            value={
                                warehouses?.find((c) => c?.value == operationDetails?.warehouseId)
                            }
                            onChange={(e) => {

                                handleUpdateWarehouse(e?.value)
                            }}
                            menuPlacement="auto"
                            menuPosition="fixed"
                            placeholder="Select"
                            style={{ borderRadius: '18px' }}
                        />
                    </div>
                </div>
            </div>
            
            {
                showClassificationField ? (
                    <>
                        <div className="row align-items-top form-group">
                            <div className="col-12" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                                <div className="textGray" style={{ width: '100px' }}>Color</div>

                                <div 
                                    style={{ 
                                        width: isMobile ? '250px' : '350px', 
                                        marginLeft: '10px', 
                                        textAlign: 'left',
                                        background: `${(operationDetails?.status === 'Completed') ? '#eaeaea' : ''}`, 
                                        borderRadius : '12px'
                                    }}>
                                    <CreatableSelect
                                        placeholder={`${colors?.length > 0 ? 'Select or type...' : 'No colors available'}`}
                                        className={`rs-container ${(operationDetails?.status === 'Completed') ? 'disabled' : ''}`}
                                        classNamePrefix="rs"
                                        options={colors}
                                        value={itemDetails?.color_name ? categoryList?.find((c) => c?.label == itemDetails?.color_name) : null}
                                        onChange={(e) => {
                                            setItemDetails({
                                                ...itemDetails,
                                                color_name: e.label,
                                            });
                                        }}
                                        isDisabled={(operationDetails?.status === 'Completed') ? true : false}
                                    />
                            
                                </div>
                                {
                                    (!isMobile && isColorsSelectionLoading) && (
                                        <div className="italic text-gray-600" style={{ marginLeft: '10px' }}>
                                            <FaSpinner className="fa-spin" /> Colors loading...
                                        </div>
                                    )
                                }
                            </div>
                        </div>

                        <div className="row align-items-top form-group">
                            <div className="col-12" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                                <div className="textGray" style={{ width: '100px' }}>IMEI</div>
                                <div style={{ width: isMobile ? '250px' : '350px', marginLeft: '10px', textAlign: 'left' }}>
                                    <textarea
                                        type="text"
                                        id="input-example"
                                        name="input-name"
                                        className="form-control"
                                        placeholder="IMEI"
                                        value={itemDetails?.imei}
                                        rows={Math.max(1, (itemDetails?.imei.match(/\n/g)?.length || 0) + 1)}
                                        onPaste={(e) => {
                                            setIsPasted(true);
                                            // Optionally handle pasted value
                                        }}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (!isPasted) {
                                                // Only allow up to 16 characters if not pasted
                                                value = value.slice(0, 16);
                                            }
                                            setItemDetails({
                                                ...itemDetails,
                                                imei: value
                                            });
                                            setIsPasted(false); // reset after handling
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                            // if ((e.key === 'Enter' && (e.ctrlKey || e.metaKey))) {
                                                e.preventDefault(); // Prevents new line
                                                handleIMEIInputKeydown(e);
                                            }
                                        }}
                                        autoComplete={'off'}
                                        disabled={!itemDetails?.product_id || !itemDetails?.quantity || !itemDetails?.color_name}
                                        autoFocus
                                    ></textarea>
                            
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="row align-items-top form-group">
                        <div className="col-12" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                            <div className="textGray" style={{ width: '100px' }}>Quantity</div>
                            <div style={{ width: isMobile ? '250px' : '350px', marginLeft: '10px', textAlign: 'left' }}>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={itemDetails.quantity}
                                    onChange={(e) => {
                                        setItemDetails({
                                            ...itemDetails,
                                            quantity: e.target.value
                                        });
                                    }}
                                    onWheel={e => e.target.blur()} 
                                />
                        
                            </div>
                        </div>
                    </div>
                )
            }

            
            <div className="row align-items-top form-group">
                <div className="col-12" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                    <div className="textGray" style={{ width: '64px' }}></div>
                    <div style={{ width: '385px', marginLeft: '10px', textAlign: 'right', display: 'flex', justifyContent: 'right' }}>
                        <button
                            type="button"
                            onClick={() => {
                                handleInboundItem()
                            }}
                            className={`btn btn-primary btn-outlined-main ${(operationDetails?.status === 'Completed') ? 'disabled' : ''}`}
                            disabled={(operationDetails?.status === 'Completed') ? true : false}
                        >
                            <FaPlus /> Add
                        </button>
                    
                    </div>
                </div>
            </div>


        </div>
    );
};

export default InboundingForm;
